import { Button as AntdButton } from '@benzinga/core-ui';
import { Lock } from '@benzinga/themed-icons';
import styles from '../scss/fallback.module.scss';
import styled from 'styled-components';

interface FallbackProps {
  onClick: (visible: boolean) => void;
  forceVisible?: boolean;
}

export const Fallback: React.FC<FallbackProps> = props => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.lockWrapper}>
        <Lock />
      </div>

      <div className={styles.content}>
        <h1 className={styles.title}>Mailing Address Required</h1>

        <p className={styles.description}>
          This feature is unavailable because we could not retrieve your mailing address per OPRA regulations. Please
          enter your full mailing address to continue.
        </p>

        <Button className={styles.button} onClick={() => props.onClick(props?.forceVisible ?? true)} size="md">
          Add Mailing Address
        </Button>
      </div>
    </div>
  );
};

const Button = styled(AntdButton)`
  justify-self: center;
  min-width: 200px;
  background-color: ${({ theme }) => theme.colors.brand};
  color: ${({ theme }) => theme.colors.brandForeground};
`;
